import http, { host } from "./httpService";

export const getContainerMasterData = async (date, ScreenType) => {
  return await http.get(host + "GetContainerDetails", { params: { _fromdate: date.fromdate, _todate:date.todate, ScreenType : ScreenType } });
};

export const getContainerMasterCountData = async (date) => {
  return await http.get(host + "GetDailyContainerCountForConMst_AB", { params: { fromdate: date.fromdate, todate:date.todate } });
};

export const insertTractorContainerData = async (data, TransporterDataId, DailyContainerPlanningId) => {
  var formData = new FormData();
  formData.append("DailyContainerPlanningId", DailyContainerPlanningId)
  formData.append("TransporterDataId", TransporterDataId)
  formData.append("GateInDate", data)
  return await http.post (host + "ABContainerMasterAdd", formData)
}

export const insertTranspoterDatabyContainerNoForVizio = async (data) => {
  var formData = new FormData();
  formData.append("ContainerNumber", data.ContainerNumber)
  formData.append("ContainerSize", data.ContainerSize)
  formData.append("BookingID", data.BookingID)
  formData.append("PickupLocation", data.PickupLocation)
  formData.append("Clearance", data.Clearance)
  formData.append("Carries", data.Carries)
  formData.append("Transporter", data.Transporter)
  formData.append("VGM", data.VGM)
  formData.append("Type", data.Type)

  const result = await fetch(
    host + "AddTranspoterDatabyContainerNo",
    {method: 'post',
    body: formData,
    headers: {
      Authorization: "ARBAPI TXlXYXlVc2VyOmRlbW8=",
    }}
  )
  return result
}

export const insertAggregateContainerData = async (data, TransporterDataId,DailyContainerPlanningId) => {
  var formData = new FormData();
  formData.append("DailyContainerPlanningAggregateId", DailyContainerPlanningId)
  formData.append("TransporterDataId", TransporterDataId)
  formData.append("GateInDate", data) 
  return await http.post (host + "AddABAggreContainer", formData)
}

export const insert5MContainerData = async (data,TransporterDataId, DailyContainerPlanningId) => {
  var formData = new FormData();
  formData.append("DailyContainerPlanning5MId", DailyContainerPlanningId)
  formData.append("TransporterDataId", TransporterDataId)
  formData.append("GateInDate", data)
  return await http.post (host + "AddAB5mContainer", formData)
}

export const updateFormContainerData = async (data) => {
  return await http.put (host + "UpdateAryabhata_ContainerMaster", data)
}

export const updateFormContainerDataAggregate = async (data) => {
  return await http.put (host + "UpdateAryabhataAggregate_ContainerMaster", data)
}

export const updateFormContainerData5M = async (data) => {
  return await http.put (host + "UpdateAryabhata5m_ContainerMaster", data)
}

export const updateContainerData = async (data) => {
  return await http.put(host + "UpdateSingleRowforContainer", data);
}
export const updateAggregateContainerData = async (data) => {
  return await http.put(host + "UpdateSingleRowforAggregateContainer", data);
}
export const updateFiveMContainerData = async (data) => {
  return await http.put(host + "UpdateSingleRowfor5MContainer", data);
}

export const uploadInvoicePackagingDocTractor = async (
  formData,
  containerId
) => {
  return await http.post(
    host + `InsertInvPackDocTractor_AB?ContainerMasterId=${containerId}`,
    formData
  );
};

export const uploadInvoicePackagingDocAggregate = async (
  formData,
  containerId
) => {
  return await http.post(
    host + `InsertInvPackDocAggregate_AB?ContainerMasterId=${containerId}`,
    formData
  );
};

export const uploadInvoicePackagingDocFiveM = async (
  formData,
  containerId
) => {
  return await http.post(
    host + `InsertInvPackDoc5M_AB?ContainerMasterId=${containerId}`,
    formData
  );
};

export const deleteInvPackingDocTractor = async (data) => {
  return await http.delete(host + `DeleteInvoicePackDocTractor?Id=${data}`);
}

export const deleteInvPackingDocAggregate = async (data) => {
  return await http.delete(host + `DeleteInvPackDocAggregate?Id=${data}`);
}

export const deleteInvPackingDoc5M = async (data) => {
  return await http.delete(host + `DeleteInvPackDoc5M_AB?Id=${data}`);
}

export const getContainerMasterDocs = async (data) => {
  return await http.get(host + "GetContainerDocById", { params: { ContainerID: data } });
};

export const deleteContainerMasterDataTractor = async (data, action) => {
  return await http.delete(host + "DeleteAryabhata_Container_Master",{params:{_id:data, _isDocData:action}})
}

export const deleteContainerMasterDataAggregate = async (data, action) => {
  return await http.delete(host + "DeleteAryabhataAggregate_Container_Master", {params:{_id:data, _isDocData:action}})
}

export const deleteContainerMasterDataFiveM = async (data, action) => {
  return await http.delete(host + "DeleteAryabhataAryabhata5M_Container_Master", {params:{_id:data, _isDocData:action}})
}

export const deleteAllContainerMasterData = async (data) => {
  return await http.delete(host + "DeleteMultipleCNTdata", {data:{_Bulkdelete : data}}, );
};

